import api from './api';

class CategoryService {
  async getCategories() {
    const response = await api.get('/v1/categories');
    return response.data;
  }

  async getCategory(id) {
    const response = await api.get(`/v1/categories/${id}`);
    return response.data;
  }

  async getCategoriesByType(type) {
    const response = await api.get(`/v1/categories/type/${type}`);
    return response.data;
  }

  async createCategory(data) {
    const response = await api.post('/v1/categories', data);
    return response.data;
  }

  async updateCategory(id, data) {
    const response = await api.put(`/v1/categories/${id}`, data);
    return response.data;
  }

  async deleteCategory(id) {
    const response = await api.delete(`/v1/categories/${id}`);
    return response.data;
  }
}

export default new CategoryService();
